import React, { useState, useEffect } from 'react';

const ZapierChatBot = ({ isActive, isDisabled, onClick }) => {

  const [visible, setVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  // Optionally preload the script again (defensive check)
  useEffect(() => {
    const scriptId = 'zapier-chatbot';
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.src = 'https://interfaces.zapier.com/assets/web-components/zapier-interfaces/zapier-interfaces.esm.js';
      script.type = 'module';
      script.async = true;
      script.id = scriptId;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <div
      style={{
        position: 'relative',
        display: 'inline-block',

      }}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      {showTooltip && (
        <div
          style={{
            position: 'absolute',
            top: '50%',
            right: '110%',
            transform: 'translateY(-50%)',
            backgroundColor: 'black',
            color: 'white',
            padding: '6px 10px',
            borderRadius: '5px',
            fontSize: '12px',
            whiteSpace: 'nowrap',
            zIndex: 999,
          }}
        >
          Chat-Bot
          <div
            style={{
              position: 'absolute',
              top: '50%',
              left: '100%',
              transform: 'translateY(-50%)',
              width: 0,
              height: 0,
              borderTop: '6px solid transparent',
              borderBottom: '6px solid transparent',
              borderLeft: '6px solid black',
            }}
          />
        </div>
      )}
      <button
        onClick={() => {
          onClick?.();
        }}

        style={{
          color: 'white',
          backgroundColor: 'white',
          border: 'none',
          cursor: 'pointer',
          color: isActive ? '#fff' : '#555',
          opacity: isDisabled ? 0.4 : 1
        }}
      >
        <img src={`${process.env.PUBLIC_URL}/assets/images/chat-bot.svg`} alt="chat-bot" style={{ width: 18, height: 18 }} />
      </button>

      {isActive && (
        <div
          style={{
            position: 'fixed',
            bottom: '40px',
            right: '55px',
            zIndex: 9999,
            boxShadow: '0 0 20px rgba(0,0,0,0.2)',
          }}
        >
          <zapier-interfaces-chatbot-embed
            is-popup="false"
            chatbot-id="cmcbh3odq0053m4mgzwm5t4tg"
            height="600px"
            width="400px"
          />
        </div>
      )}
    </div>
  );
};

export default ZapierChatBot;